export default __webpack_public_path__ + "static/media/polaroid28.65d89b17.jpg";